const Content = (props) => {
    const isEmpty = () => {
        return (
            <div className="flex h-full w-full items-center justify-center font-bold text-gray-900">
                __
            </div>
        );
    }

    const isSingle = ({permission}) => {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <input
                    type="checkbox"
                    className="h-4 w-4 accent-personalized"
                    disabled={!props.isEditor}
                    checked={permission.checked}
                    onChange={(e) => props.updateCheck(permission.Id, e.target.checked)}
                />
            </div>
        )
    }

    const isMultiple = ({permission}) => {
        return (
            <label
                key={permission.Id}
                className="flex cursor-pointer items-center justify-between gap-3 px-3 py-2 text-xs hover:bg-gray-50"
                >
                <span className="text-gray-700">
                    {permission.Description || 'Sin descripción'}
                </span>
                <input 
                    type="checkbox"
                    className="h-4 w-4 accent-personalized" 
                    disabled={!props.isEditor}
                    checked={permission.checked}
                    onChange={(e) => props.updateCheck(permission.Id, e.target.checked)}
                />
            </label>
        )
    }

    return {
        IsEmpty: isEmpty,
        IsSingle: isSingle,
        IsMultiple: isMultiple
    }
};

export default Content;
